module.exports = __webpack_public_path__ + "static/media/movemybike BIKE PARCEL.b8d0729f.jpg";